module.exports = __webpack_public_path__ + "static/media/intro-text.62cd7e75.png";